/* MAISON AVIRE · Storefront V3 — Reveal, Header-Overlay, Hero-Video, Sticky CTA */
(function(){
  'use strict';
  if (window.__ma3Init) return;
  window.__ma3Init = true;

  /* Scroll-Reveal (einmalig, ohne Load-Animation) */
  function reveal(){
    var nodes = document.querySelectorAll('.ma3 .ma3-rv:not([data-ma3-seen])');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) { nodes.forEach(function(n){ n.setAttribute('data-ma3-seen','1'); n.classList.add('ma3-in'); }); return; }
    if (!window.__ma3IO) {
      window.__ma3IO = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('ma3-in'); window.__ma3IO.unobserve(e.target);} }); }, { rootMargin:'0px 0px -10% 0px', threshold:.08 });
    }
    nodes.forEach(function(n){ n.setAttribute('data-ma3-seen','1'); window.__ma3IO.observe(n); });
  }

  function hero(){
    var h = document.querySelector('.ma3 .ma3-hero');
    if (!h) return;
    var hs = document.querySelector('.header-section');
    var hc = hs && hs.querySelector('header-component');
    var hh = 0, pos = '';
    if (hc) { pos = getComputedStyle(hc).position; hh = hc.getBoundingClientRect().height || 0; }
    /* Sticky-Header im Fluss -> Hero darunter ziehen. Ist der Theme-Header bereits transparent/absolut, nur den Overlay-Zustand setzen. */
    if (hc && (pos === 'sticky' || pos === 'fixed') && hh > 0 && hh < 200) {
      document.documentElement.style.setProperty('--ma3-hero-pull', (-hh) + 'px');
    }
    var st = document.querySelector('.ma3 .ma3-sticky');
    function onS(){
      var y = window.scrollY || document.documentElement.scrollTop;
      var top = h.getBoundingClientRect().top + y;
      if (hs && hc) hs.classList.toggle('ma3-over', y < top + h.offsetHeight - (hh || 64));
      if (st) st.classList.toggle('on', y > top + h.offsetHeight * .7);
    }
    window.addEventListener('scroll', onS, { passive:true }); onS();
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var vids = h.querySelectorAll('video');
    function start(v){
      if (v.getAttribute('data-ma3-vid') === '1') return;
      var r = v.getBoundingClientRect(); if (!r.width || !r.height) return;
      v.setAttribute('data-ma3-vid','1'); v.muted = true; v.playsInline = true; v.preload = 'auto';
      v.addEventListener('playing', function(){ v.classList.add('is-playing'); });
      var p = v.play(); if (p && p.catch) p.catch(function(){});
    }
    function all(){ for (var i=0;i<vids.length;i++) start(vids[i]); }
    all();
    var t; window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(all, 200); });
  }

  /* Capture-Modus (?ma3static[&zoom]): feste Hoehen statt svh, alle Reveals sichtbar, Preview-Bar aus - nur fuer Screenshots */
  if (location.search.indexOf('ma3static') > -1) {
    var z = location.search.indexOf('zoom') > -1;
    var cs = document.createElement('style');
    cs.textContent = '.ma3 .ma3-rv{opacity:1!important;transform:none!important}.ma3 .ma3-hero{height:' + (z ? 812 : 900) + 'px!important;min-height:0!important}.ma3 .ma3-hero h1 .l span{animation:none!important;transform:none!important}.ma3 .ma3-ed,.ma3 .ma3-stmt{min-height:0!important}#preview-bar-iframe{display:none!important}' + (z ? 'html{zoom:2}.ma3 .ma3-stmt h2{font-size:48px!important}' : '');
    document.head.appendChild(cs);
  }

  function init(){ reveal(); hero(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function(){ reveal(); });
})();
